import PropTypes from "prop-types"
import { useContext, useEffect, useState } from "react"
import { useQuery } from "react-query"
import { listCategories } from "~/actions/categories"
import FilterCheckbox from "~/components/Common/FilterCheckbox"
import NewActionBar from "~/components/Common/NewActionBar"
import NewActionButton from "~/components/Common/NewActionButton"
import NewSearchInput from "~/components/Common/NewSearchInput"
import NewSelect from "~/components/Common/NewSelect"
import AddDocDialog from "~/components/Docs/AddDocDialog"
import DocList from "~/components/Docs/DocList"
import PaginationButtons from "~/components/Docs/PaginationButtons"
import { DEFAULT_OPTIONS, DOCS_TYPES } from "~/constants/docs"
import AppContext from "~/contexts/App"
import { useGetDocs } from "~/hooks/useGetDocs"
import Page from "~/pages/Page"

const List = (props) => {
  const [options, setOptions] = useState(DEFAULT_OPTIONS)
  const { data: categories } = useQuery("categories", () => listCategories())
  const { setPageTitle, setPageSubTitle } = useContext(AppContext)

  const [openDialog, setOpenDialog] = useState(false)
  const { data, refetch, isFetching } = useGetDocs(options)

  useEffect(() => {
    setPageTitle("Docs")
    setPageSubTitle(data?.total || 0)
  }, [data])

  const closeDialog = () => {
    setOpenDialog(false)
  }

  const openDialogFunc = () => {
    setOpenDialog(true)
  }

  const handleUpdateOptions = (key, value) => {
    setOptions((oldState) => ({
      ...oldState,
      page: 1,
      per_page: 10,
      [key]: value === "All Docs" || value === "All Categories" ? "" : value,
    }))
  }
  return (
    <Page>
      <div className="relative h-full">
        <NewActionBar>
          <NewActionButton
            title="new doc"
            action={openDialogFunc}
            haveIcon={true}
          />
          <NewSelect
            options={DOCS_TYPES}
            selected={options.category}
            handleSelectOption={(value) => handleUpdateOptions("type", value)}
            className="min-w-[120px]"
          />
          <NewSelect
            options={
              categories
                ? [
                    { name: "All Categories", id: "All Categories" },
                    ...categories,
                  ]
                : []
            }
            selected={options.type}
            handleSelectOption={(value) =>
              handleUpdateOptions("category", value)
            }
            className="min-w-[120px]"
          />
          <NewSearchInput
            handleSearch={(value) => handleUpdateOptions("search", value)}
            className="md:mr-10"
          />
          <FilterCheckbox
            label="Hidden"
            handleCheckbox={(value) => handleUpdateOptions("hidden", value)}
            value={options.hidden ?? false}
            id="hidden-checkbox"
          />
          <div className="flex-grow"></div>
          <PaginationButtons
            setOptions={setOptions}
            currentPage={options.page ?? 1}
            totalPages={data?.total_pages ?? 0}
            isFetching={isFetching}
          />
        </NewActionBar>
        <div className="overflow-y-auto h-[calc(100%-150px)] md:h-[calc(100%-95px)] pb-20">
          <DocList
            docs={data?.data}
            total={data?.total}
            setOptions={setOptions}
            isFetching={isFetching}
          />
        </div>
        <AddDocDialog
          open={openDialog}
          closeDialog={closeDialog}
          refetchDocs={refetch}
        />
      </div>
    </Page>
  )
}

List.propTypes = {
  options: PropTypes.object,
  setOptions: PropTypes.func,
}

export default List
